import {Directive, OnChanges, SimpleChanges} from '@angular/core';
import {PaginacaoDto} from '@core/dto/paginacao-dto';
import {PaginationControlsDirective} from 'ngx-pagination';


@Directive()
export abstract class PaginatorCustomDirective implements OnChanges {
  abstract pageResponse: PaginacaoDto<any>;
  abstract p: PaginationControlsDirective;
  abstract itemsPerPage: number;
  abstract items: any[];
  abstract changeEvent(page: number): void;

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items) {
      if (this.pageResponse) {
        this.redirectPageIfPageNotExist();
        return;
      }
      const current = this.p?.getCurrent();
      const maxPage = Math.ceil(this.p?.getTotalItems() / this.itemsPerPage) || 1;
      if (current > maxPage) {
        setTimeout(() => this.p.setCurrent(maxPage), 1);
      }
    }
  }

  redirectPageIfPageNotExist() {
    if (this.pageResponse) {
      const current = this.pageResponse.currentPage ?? 1;
      const total = this.pageResponse?.total ?? 0;
      const itemsPerPage = this.pageResponse?.numPerPage ?? 0;
      const maxPage = Math.ceil(total / itemsPerPage) || 1;

      if (current > maxPage) {
        this.pageResponse.currentPage = maxPage;
        this.changeEvent(maxPage);
      }
    }
  }
}
